<template>
	<div v-if="isLoaded">
		<div class="tip-content" v-if="isShowTip && !['audited'].includes(tipStatus)">
			<span class="tip-text">{{tipInfoMap[tipStatus].tipText}}</span>
			<span class="tip-rejectreason" v-if="isShowRejectReason" @click="lookReason">查看原因</span>
			<el-button class="tip-btn" type="primary" @click="tipClick">{{tipInfoMap[tipStatus].tipBtnText}}</el-button>
			<i class="el-icon-circle-close tip-close" @click="tipClose"></i>
		</div>

		<!-- 注册申请表单 -->
		<el-dialog v-if="isShowApplyForm && !['audited', 'notAudited'].includes(tipStatus)" :visible.sync="isShowApplyForm" :modal-append-to-body='false' destroy-on-close width="900px" :close-on-click-modal="false">
			<checkin-apply :isLimitOfCheckIn='false' formHeight='500px' @applySuccess='applySuccess' @refreshStatus='refreshStatus'></checkin-apply>
		</el-dialog>
	</div>
</template>

<script>
	import CheckInApply from './CheckInApply.vue';
	import { getParam } from '../../utils/api-utils/api-params.js'
	import { getCustomerInfo } from '../../utils/api-utils/api-customer.js'
	import {
		getRegisterApplyDetail,
	} from '../../utils/api-utils/api-customer.js'
	export default {
		name: 'FloatLoginAndApplyTips',
		props: {
			tel: {
				type: String,
				default: ""
			},
		},
		components: {
			'checkin-apply': CheckInApply,
		},
		data() {
			return {
				isLoaded: false,
				tipStatusMap: {
					0: 'notAudited',
					1: 'audited',
					2: 'rejected',
					3: 'notApplied',
				}, // 当前申请状态映射	
				tipInfoMap: {
					notLogin: {
						tipText: '请登录账号验证身份',
						tipBtnText: '立即登录',
					},
					notApplied: {
						tipText: '您无法查看价格，请申请权限',
						tipBtnText: '立即申请',
					},
					rejected: {
						tipText: '商家已驳回申请，可再次申请查看',
						tipBtnText: '立即申请',
					},
					notAudited: {
						tipText: '商家审核通过即可查看价格并下单',
						tipBtnText: '审核中',
					},
					auditedNeedLogin: {
						tipText: '请重新登录',
						tipBtnText: '立即登录',
					},

				}, // 提示信息映射
				tipStatus: '', //当前状态
				telForRegister: localStorage.getItem("telForRegister"), //当前状态
				isShowRejectReason: false, // 是否展示驳回原因
				isShowTip: false, // 是否展示提示
				isShowApplyForm: false // 是否展示申请表单弹窗
			}
		},
		created: async function() {
			this.telForRegister = localStorage.getItem("telForRegister")

			// 获取参数
			await this.loadParamAndCustomer();

			// 获取申请状态
			await this.getApplyStatus();

			this.isLoaded = true;
		},
		async mounted() {
			let that = this
			this.$eventBus.$on('setCustomerId', async msg => {
				that.telForRegister = localStorage.getItem("telForRegister")
				await that.loadParamAndCustomer();
				that.getApplyStatus();
			});

			//监听表单弹窗展示
			this.$eventBus.$on("showApplyForm", async () => {
				that.telForRegister = localStorage.getItem("telForRegister")
				await that.loadParamAndCustomer();
				that.getApplyStatus();

				this.isLoaded = true;
				that.isShowApplyForm = !['audited', 'notAudited'].includes(that.tipStatus);
			})
		},
		methods: {
			/**
			 * 加载参数
			 */
			async loadParamAndCustomer() {
				this.customerInfo = await getCustomerInfo({}, true);

				let params = await getParam("isOpenLoginLimit,loginLimitType");

				this.isOpenLoginLimit = params.isOpenLoginLimit == '1';
				this.loginLimitType = params.loginLimitType;
				this.isShowTip = this.isOpenLoginLimit && this.loginLimitType == 'auditLimitOfPrice'
			},

			/**
			 * 查询 申请状态
			 */
			async getApplyStatus() {
				// 已存在档案
				if (this.customerInfo.phone) {
					this.tipStatus = 'audited';
					return
				}

				// 展示登录
				if (!this.telForRegister) {
					this.tipStatus = 'notLogin';
					return
				}

				let tempApplyStatusObj = await getRegisterApplyDetail(this.telForRegister);

				this.tipStatus = this.tipStatusMap[tempApplyStatusObj.auditStatus === 0 ? 0 : (tempApplyStatusObj.auditStatus || 3)];
				this.isShowRejectReason = this.tipStatus == 'rejected' && !!tempApplyStatusObj.rejectReason;
				this.rejectReason = tempApplyStatusObj.rejectReason

				// 判断是否是审核完需要重新登录 档案被删除 但是 审核状态是通过 也需要重新登录
				if (!this.customerInfo.phone && this.tipStatus == 'audited') {
					this.tipStatus = 'auditedNeedLogin';
					return
				}
				console.log(this.tipStatus)
			},

			/**
			 * 按钮点击
			 */
			tipClick() {
				if (['notLogin', 'auditedNeedLogin'].includes(this.tipStatus)) {
					localStorage.removeItem("telForRegister");
					this.$eventBus.$emit("showLoginDialog", true, true);
					return
				}

				if (!['audited', 'notAudited'].includes(this.tipStatus)) {
					this.isShowApplyForm = true;
				}
			},

			/**
			 * 关闭登录弹窗
			 */
			async closeLoginDialog() {
				this.isShowLoginDialog = false;
			},

			/**
			 * 查看驳回原因
			 */
			lookReason() {
				this.$alert(this.rejectReason, '驳回原因', {
					showConfirmButton: false,
				});
			},

			/**
			 * 注册申请成功
			 */
			applySuccess() {
				this.tipStatus = 'notAudited';
				this.isShowApplyForm = false;
				this.isShowRejectReason = false;
			},

			/**
			 * 审核成功
			 */
			refreshStatus() {
				this.tipStatus = 'audited';
			},
			
			/**
			 * 隐藏浮窗
			 */
			tipClose() {
				this.isLoaded = false;
			},

		},
	}
</script>

<style scoped>
	.tip-content {
		width: 1200px;
		margin: 0 auto;
		background-color: white;
		box-shadow: 0px 0px 10px #999;
		margin-top: 10px;
		border-radius: 5px;
		padding: 10px 20px;
		text-align: center;
		box-sizing: border-box;
		position: relative;
	}

	.tip-text {
		margin-right: 20px;
	}

	.tip-rejectreason {
		margin-right: 20px;
		color: #C8741A;
		cursor: pointer;
	}

	.tip-btn {
		margin-right: 20px;
	}

	.tip-close {
		position: absolute;
		right: 15px;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
	}

	/deep/ .el-button {
		padding: 9px 20px;
	}

	/deep/ .el-dialog {
		margin-top: 20px !important;
	}

	/deep/.el-message-box__message p {
		word-break: break-all;
	}
</style>